<template>
  <section>
    <form-spinner v-if="loading" />
    <div v-else-if="valid" class="frame valid">
      <ul class="etapas">
        <li>
          <a href="#" 
             :class="['btn', { 'btn-primary-light': etapa > 1, 'btn-primary': etapa == 1, 'btn-secondary': etapa < 1 }]" 
             @click.prevent="toggleStep(1)">
            Dados Pessoais
          </a>
        </li>
        <li>
          <a href="#" 
             :class="['btn', { 'btn-primary-light': etapa > 2, 'btn-primary': etapa == 2, 'btn-secondary': etapa < 2 }]" 
             :disabled="etapa < 2" 
             @click.prevent="toggleStep(2)">
            Função
          </a>
        </li>
        <li>
          <a href="#" 
             :class="['btn', { 'btn-primary-light': etapa > 3, 'btn-primary': etapa == 3, 'btn-secondary': etapa < 3 }]" 
             :disabled="etapa < 3" 
             @click.prevent="toggleStep(3)">
            Unidade
          </a>
        </li>
      </ul>

      <template v-if="etapa == 1">
        <div class="table-wrap">
          <h3>Criar Colaborador</h3>
          <div class="row nop nom" v-if="informacoes">
            <div class="col-md-12">
              <h4 class="">Informações Pessoais</h4>
          </div>
          <div class="form-group col-md-6">
            <label>{{ informacoes.Basicos.tipo == '1' ? 'Nome' : 'Razão Social' }}</label>
            <input-control type="text" :placeholder=" informacoes.Basicos.tipo == '1' ? 'Nome' : 'Razão Social' " v-model="informacoes.Basicos.nome" name="nome" :valid="valid.nome" @keyup="valid.nome = true" required/>
          </div>
          <div class="form-group col-md-6">
            <label>Email</label>
            <input-control type="text" placeholder="Email" v-model="informacoes.Basicos.email" name="email" :valid="valid.email" @keyup="valid.email = true" required />
          </div>
          <div class="form-group col-md-6">
            <label>CPF / CNPJ</label>
            <input-control type="text" :placeholder="informacoes.Basicos.cpf"  name="cpf" :valid="valid.cpf" @keyup="valid.cpf = true" v-model="informacoes.Documento.cpf" :masking="masked ? 'cpf' : null" required/>
          </div>
          <div class="form-group col-md-4">
            <label>Data de Nascimento</label>
            <input-control
              type="date"
              placeholder="dd/mm/aaaa"
              v-model="informacoes.Basicos.dataNascimento"
              name="dataNascimento"
              maxlength="10"
              :valid="valid.dataNascimento"
              required
            />
          </div>

          <div class="form-group col-md-2">
            <label>Gênero</label>
            <select-control placeholder="Gênero" v-model="informacoes.Basicos.sexo" :options="options.generos"  name="Gênero" :valid="valid.sexo" @keyup="valid.sexo = true" required/>
          </div>
          <div class="form-group col-md-6">
            <label>RG</label>
            <input-control type="text" placeholder="RG" v-model="informacoes.Documento.rg" name="rg" :valid="valid.rg" @keyup="valid.rg = true"/>
          </div>
          <div class="form-group col-md-2">
            <label>Órgão Emissor</label>
            <select-control
              v-model="informacoes.Documento.rgEmissor"
              :options="options.rgEmissor"
              placeholder="Selecione"
              name="rgEmissor"
              type="text"
              :valid="valid.rgEmissor"
              @keyup="valid.rgEmissor = true"
              @focus="triggerTip && triggerTip(null, 'rgEmissor')"
              required
            />
          </div>
          <div class="form-group col-md-4">
            <label>Nacionalidade</label>
            <select-control placeholder="Nacionalidade" v-model="informacoes.Basicos.idNacionalidade" :options="options.nacionalidades"  name="Nacionalidade" :valid="valid.idNacionalidade" @keyup="valid.idNacionalidade = true" required/>
          </div>
          <div class="form-group col-md-6">
            <label>Telefone</label>
            <input-control type="text" placeholder="Telefone" v-model="informacoes.Basicos.telefonefixo" :masking="masked ? 'telefone' : null" />
          </div>
          <div class="form-group col-md-6">
            <label>Celular</label>
            <input-control type="text" placeholder="Celular" v-model="informacoes.Basicos.telefonecelular" name="telefonecelular" :valid="valid.telefonecelular" @keyup="valid.telefonecelular = true" :masking="masked ? 'telefone' : null" required/>
          </div>
        </div>
        <div class="row nop nom" v-if="informacoes">
          <div class="col-md-12"></div>
          <div class="col-md-12">
            <h5 class="">Endereço</h5>
          </div>
          <div class="form-group col-md-4">
            <label>CEP</label>
            <input-control type="text" placeholder="CEP" v-model="informacoes.Endereco.cep" :masking="masked ? 'cep' : null" @blur="getAddressFromCEP" @change="getAddressFromCEP" name="cep" :valid="valid.cep" @keyup="valid.cep = true" required/>
          </div>
        </div>
        <div class="row nop nom" v-if="informacoes">
          <div class="form-group col-md-8">
            <label>Endereço</label>
            <input-control type="text" placeholder="Logradouro" v-model="informacoes.Endereco.logradouro" readonly/>
          </div>
          <div class="form-group col-md-4">
            <label>Número</label>
            <input-control type="text" placeholder="Número" v-model="informacoes.Endereco.numero" name="numero" :valid="valid.numero" @keyup="valid.numero = true" required/>
          </div>
          <div class="form-group col-md-5">
            <label>Complemento</label>
            <input-control type="text" placeholder="Complemento" v-model="informacoes.Endereco.complemento" />
          </div>
          <div class="form-group col-md-7">
            <label>Bairro</label>
            <input-control type="text" placeholder="Bairro" v-model="informacoes.Endereco.bairro" required readonly/>
          </div>
          <div class="form-group col-md-10">
            <label>Cidade</label>
            <input-control type="text" placeholder="Cidade" v-model="informacoes.Endereco.nomecidade" readonly/>
          </div>
          <div class="form-group col-md-2">
            <label>UF</label>
            <input-control type="text" placeholder="UF" v-model="informacoes.Endereco.nomeUf" maxlenght="2" :masking="masked ? 'uf' : null" readonly/>
          </div>
          </div>
        </div>
      </template>


    <template v-if="etapa == 2">
      <div class="flex">

        <div class="flex-1 colab-func">
          <header>
            <div class="cargo">
              <h3>Selecione o cargo do novo colaborador</h3>
            </div>
          </header>

          <div class="row nop nom">
            <div class="col-md-6 form-group">
              <select-control :options="options.unidades" label="Unidade" v-model="filter.idUnidade" placeholder="Selecione"/>
            </div>
            <div class="col-md-6 form-group">
              <select-control :options="options.departamentos" label="Departamento" v-model="filter.idDepartamento" placeholder="Selecione" @change="changeDepartamento"/>
            </div>
            <div class="col-md-6 form-group">
              <select-control :options="options.setores" label="Setor" v-model="filter.idSetor" placeholder="Selecione" @change="changeSetor"/>
            </div>
            <div class="col-md-6 form-group">
              <select-control :options="options.funcoes" label="Função" v-model="filter.idFuncao" placeholder="Selecione"/>
            </div>
            <div class="col-md-3 form-group">
              <select-control :options="options.situacoes" label="Situação" v-model="filter.idSituacao" placeholder="Selecione"/>
            </div>
          </div>
        </div>
      </div>
    </template>

      <template v-if="etapa == 3">
        <header>
          <h3>Selecione as unidades permitidas</h3>
        </header>
        <div class="list-track">
          <div class="lists">
            <div>
              <header>
                <p>{{ unidades.length }} itens</p>
                <a href="#" class="btn btn-secondary btn-small" @click.prevent="selectAllUnidades()">Selecionar Todos</a>
              </header>
              <card :listed="false" :boxed="false">
                <div class="search">
                  <input-control placeholder="O que você procura?" cssClass="invis" v-model="uniQuery" @keyup="searchFuncoes('funcoes')" search preventSearchButton/>
                </div>
                <div class="list-selector" v-if="unidades">
                  <ul >
                    <li v-for="(unidade, i) in unidades" :key="unidade" @click="selectUnidade(unidade, i)" class="noselect">
                        {{ unidade.descricao }}
                      </li>
                  </ul>
                </div>
              </card>
            </div>
            <span>
              <fa :icon="['far', 'arrow-right-arrow-left']" />
            </span>
            <div>
              <header>
                <p>{{ unidadesSelecionadas.length }} itens selecionados</p>
                <a href="#" class="btn btn-secondary btn-small" @click.prevent="unselectAllUnidades()">Remover Todos</a>
              </header>
              <card :listed="false" :boxed="false">
                <div class="search">
                  <input-control placeholder="O que você procura?" cssClass="invis" v-model="sUniQuery" @keyup="searchFuncoes('selecionadas')" :disabled="unidadesSelecionadas.length == 0" search preventSearchButton/>
                </div>
                <div class="list-selector" v-if="unidades && unidadesSelecionadas.length > 0">
                  <ul >
                    <li v-for="(unidade, i) in unidadesSelecionadas" :key="unidade" @click="removeUnidade(unidade, i)" class="noselect">
                      {{ unidade.descricao }}
                    </li>
                  </ul>
                </div>
                <div v-else class="emptyList">
                  <div>
                    <fa :icon="['fas', 'square-dashed-circle-plus']" class="ic" />
                    <h5>Selecione os itens na lista ao lado</h5>
                  </div>
                </div>
              </card>
            </div>
          </div> 
        </div>
      </template>
    </div>
      <footer :class="{ hom: hom }">
        <div>
          <a href="#" @click.prevent="goTo('prev')" class="btn btn-secondary" v-if="etapa > 1">Voltar</a>
        </div>
        <div>
          <a href="#" @click.prevent="goTo('next')" class="btn btn-primary" v-if="etapa < 3">Próximo</a>
          <a href="#" @click.prevent="save()" class="btn btn-primary" v-if="etapa == 3">Salvar</a>
        </div>
    </footer>
  </section>
</template>

<script>
import { getCEP } from '@/services/utils.service'
import UserService from '@/services/user.service'
import { createSelectOptions, clearMask } from '@/services/utils.service'
import AdmService from '@/services/adm.service'
import moment from 'moment'
export default {
  components: {
    
  },
  data() {
    return {
    loading: false,
    informacoes: null,
    masked: true,
    lookingForCep: false,
    etapa: 1,
    unidadesBkp: null,
    unidadesSelecionadasBkp: null,
    uniQuery: null,
    sUniQuery: null,
    searchWait: null,
    unidades: [],
    unidadesSelecionadas: [],
      valid: {
        tipo: true,
        nome: true,
        email: true,
        telefonefixo: true,
        telefonecelular: true,
        cpf: true,
        dataNascimento: true,
        idNacionalidade: true,
        sexo: true,
        rg: true,
        rgEmissor: true,
        cep: true,
        logradouro: true,
        numero: true,
      },
      options: {
        unidades: [],
        departamentos: [],
        setores: [],
        funcoes: [],
        situacoes: [],
        rgEmissor: [],
        generos: [
          { label: 'Feminino', value: 'F' },
          { label: 'Masculino', value: 'M' },
          { label: 'Outros', value: 'O' },
        ],
        nacionalidades: [],
      },
      optionsScope: {
        unidades: [],
        departamentos: [],
        setores: [],
        funcoes: [],
        situacoes: []
      },
      wait: {
        unidades: false,
        departamentos: false,
        setores: false,
        funcoes: false,
        situacoes: false,
      },
      filter: {
        idUnidade: null,
        idDepartamento: null,
        idFuncao: null,
        idSetor: null,
        idSituacao: null,
        nome: null
      }
    };
  },
  computed: {
    currentUser() {
      return localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null;
    },
  },
mounted() {
  if (this.$route.query.reload) {
  this.fetchColaboradores()
  }
  this.hom = process.env.VUE_APP_ENV != 'PROD'
  const action = this.$route.params.action
  const id = this.$route.params.id

  console.log('Action:', action)
  console.log('ID:', id)

  if (action === 'ver' && id) {
    this.carregarColaborador(id)
  } else {
    this.$store.dispatch('checkout/get').then((response) => {
      this.informacoes = response
      this.fetchUser()
    });
  }

  this.getOrgaosEmissores();
  this.getNacionalidades();
  this.getMinhasUnidades();
  this.getDepartamentos();
  this.getSetores();
  this.getFuncoes();
  this.getSituacoes();
  this.getUnidade();
},
  methods: {
save() {
  const id = this.$route.params.id;
  const isEdicao = !!id;

  const payload = {
    colaborador: {
      Basicos: {
        nome: this.informacoes.Basicos.nome,
        email: this.informacoes.Basicos.email,
        dataNascimento: moment(this.informacoes.Basicos.dataNascimento).format('DD/MM/YYYY'),
        telefonefixo: clearMask('phone', this.informacoes.Basicos.telefonefixo),
        telefonecelular: clearMask('phone', this.informacoes.Basicos.telefonecelular),
        sexo: this.informacoes.Basicos.sexo,
        idNacionalidade: this.informacoes.Basicos.idNacionalidade,
        idUnidade: this.informacoes.Basicos.idUnidade,
        idDepartamento: this.informacoes.Basicos.idDepartamento,
        idSetor: this.informacoes.Basicos.idSetor,
        idFuncao: this.informacoes.Basicos.idFuncao,
        idSituacao: this.informacoes.Basicos.idSituacao,
        tipo: 1
      },
      Documento: {
        cpf: clearMask('cpf', this.informacoes.Documento.cpf),
        rg: this.informacoes.Documento.rg,
        rgEmissor: this.informacoes.Documento.rgEmissor
      },
      Endereco: {
        cep: clearMask('cep', this.informacoes.Endereco.cep),
        logradouro: this.informacoes.Endereco.logradouro,
        numero: this.informacoes.Endereco.numero,
        complemento: this.informacoes.Endereco.complemento,
        bairro: this.informacoes.Endereco.bairro,
        idUf: this.informacoes.Endereco.idUf,
        idCidade: this.informacoes.Endereco.idCidade
      },
      listaUnidadesSelected: this.unidadesSelecionadas ?? []
    }
  };

  console.log("Payload enviado:", payload);

  window.spinner.emit('open');

  const request = isEdicao
    ? AdmService.updateColaborador(id, payload)
    : AdmService.saveColaborador(payload);

  request.then(response => {
    if (response.status === 200) {
      window.toaster.emit('open', {
        style: "success",
        message: isEdicao
          ? "Colaborador atualizado com sucesso."
          : "Colaborador registrado com sucesso.",
        floater: true
      });

      this.$router.push({ name: 'colaboradores', query: { reload: true } });
    }

    window.spinner.emit('close');
  },
  error => {
    console.error("Erro ao salvar colaborador:", error);
    window.toaster.emit('open', {
      style: "error",
      message: "Erro ao salvar colaborador.",
      floater: true
    });
    window.spinner.emit('close');
  });
}
,
    getMinhasUnidades () {
      UserService.getMinhasUnidades().then(
        response => {
          console.log("getMinhasUnidades:", response.data)
          this.options.unidades = createSelectOptions(response.data, 'idUnidade' ,'descricao')
          this.optionsScope.unidades = createSelectOptions(response.data, 'idUnidade' ,'descricao')
          this.wait.unidades = true
          this.finishLoad()
        },
        error => {
          console.error(error)
        }
      )
    },
    getDepartamentos () {
      AdmService.getDepartamentos().then(
        response => {
          console.log("getDepartamentos:", response.data)
          if (this.options && this.options.departamentos) {
          this.options.departamentos = createSelectOptions(response.data, 'idDepartamento' ,'nome')
          this.optionsScope.departamentos = createSelectOptions(response.data, 'idDepartamento' ,'nome')
          this.wait.departamentos = true
          this.finishLoad()
        }
      },
        error => {
          console.error(error)
        }
      )
    },
    getSetores () {
      AdmService.getSetores().then(
        response => {
          console.log("getSetores:", response.data)
          this.options.setores = createSelectOptions(response.data, 'idSetor' ,'descricao')
          this.optionsScope.setores = createSelectOptions(response.data, 'idSetor' ,'descricao')
          this.wait.setores = true
          this.finishLoad()
        },
        error => {
          console.error(error)
        }
      )
    },
    getFuncoes () {
      AdmService.getListFuncoes().then(
        response => {
          console.log("getFuncoes:", response.data)
          this.options.funcoes = createSelectOptions(response.data, 'idFuncao' ,'nome')
          this.optionsScope.funcoes = createSelectOptions(response.data, 'idFuncao' ,'nome')
          this.wait.funcoes = true
          this.finishLoad()
        },
        error => {
          console.error(error)
        }
      )
    },
carregarColaborador(id) {
  console.log("Buscando colaborador com ID:", id);
  this.loading = true;

  AdmService.getColaborador(id).then(
    response => {
      console.log("Dados recebidos:", response.data);
      const data = response.data;

      this.informacoes = {
        Basicos: {
          nome: data.Basicos?.nome || '',
          email: data.Basicos?.email || '',
          dataNascimento: data.Basicos?.dataNascimento || '',
          telefonefixo: data.Basicos?.telefonefixo || '',
          telefonecelular: data.Basicos?.telefonecelular || '',
          sexo: data.Basicos?.sexo || '',
          idNacionalidade: data.Basicos?.idNacionalidade || '',
          idUnidade: data.Basicos?.idUnidade || null,
          idDepartamento: data.Basicos?.idDepartamento || null,
          idSetor: data.Basicos?.idSetor || null,
          idFuncao: data.Basicos?.idFuncao || null,
          idSituacao: data.Basicos?.idSituacao || null,
        },
        Documento: {
          rg: data.Documento?.rg || '',
          rgEmissor: data.Documento?.rgEmissor || '',
          cpf: data.Documento?.cpf || ''
        },
        Endereco: {
          cep: data.Endereco?.cep || '',
          logradouro: data.Endereco?.logradouro || '',
          numero: data.Endereco?.numero || '',
          complemento: data.Endereco?.complemento || '',
          bairro: data.Endereco?.bairro || '',
          idCidade: data.Endereco?.idCidade || '',
          idUf: data.Endereco?.idUf || ''
        }
      };

      this.filter.idUnidade = this.informacoes.Basicos.idUnidade
      this.filter.idDepartamento = this.informacoes.Basicos.idDepartamento
      this.filter.idSetor = this.informacoes.Basicos.idSetor
      this.filter.idFuncao = this.informacoes.Basicos.idFuncao
      this.filter.idSituacao = this.informacoes.Basicos.idSituacao
      this.changeDepartamento()
      this.changeSetor()

      this.getAddressFromCEP(this.informacoes.Endereco.cep)
    },
    error => {
      console.error("Erro ao carregar colaborador:", error);
      window.toaster.emit('open', { style: 'error', message: 'Erro ao carregar colaborador.', floater: true });
    }
  ).finally(() => {
    this.loading = false;
  });
},
    getUnidade () {
      UserService.getMinhasUnidades().then(
        response => {
          this.unidades = response.data
          this.unidadesBkp = Object.assign([], response.data)
          this.wait.unidades = true
          this.finishLoad()
        },
        error => {
          console.error(error)
        }
      )
    },
    addUnidadesToList () {
      this.unidades.map(( k, i) => {
        if ( this.canal.unidades.includes(k.idUnidade) ) {
          this.selectUnidade(k, i)
        }
      })
    },
    selectUnidade ( unidade, i ) {
      this.unidadesSelecionadas.push(unidade)
      this.unidadesSelecionadasBkp = Object.assign([], this.unidadesSelecionadas)
      this.unidades.splice(i,1)
    },
    removeUnidade ( unidade, i ) {
      this.unidades.push(unidade)
      this.unidadesSelecionadas.splice(i,1)
    },
    selectAllUnidades () {
      this.unidadesSelecionadas = [...this.unidadesSelecionadas, ...this.unidades];
      this.unidades = [];
    },
    unselectAllUnidades () {
    this.unidades = [...this.unidades, ...this.unidadesSelecionadas.filter(u => !this.unidades.find(item => item.idUnidade === u.idUnidade))];
    this.unidadesSelecionadas = [];
    },
    getSituacoes () {
      AdmService.getSituacoes().then(
        response => {
          console.log("getSituacoes:", response.data)
          this.options.situacoes = createSelectOptions(response.data, 'idSituacao' ,'descricao')
          this.optionsScope.situacoes = createSelectOptions(response.data, 'idSituacao' ,'descricao')
          this.wait.situacoes = true
          this.finishLoad()
        },
        error => {
          console.error(error)
        }
      )
    },
    finishLoad () {
      const done = !Object.values(this.wait).some( a => !a)
      console.log("done:", done)
      if ( done ) {
        this.ready = true
      }
    },
    changeDepartamento () {
      const setores = this.optionsScope.setores.filter(a => a.idDepartamento == this.filter.idDepartamento)
      this.options.setores = setores

      const funcoes = this.optionsScope.funcoes.filter(a => a.idDepartamento == this.filter.idDepartamento)
      this.options.funcoes = funcoes
    },
    changeSetor () {
      const funcoes = this.optionsScope.funcoes.filter(a => a.idSetor == this.filter.idSetor)
      this.options.funcoes = funcoes
    },
    goTo(dir) {
      if (dir === 'prev') {
        if (this.etapa > 1) {
          this.toggleStep(this.etapa - 1);
        }
      }
      if (dir === 'next') {
        if (this.etapa < 3) {
          const valid = this.saveEtapa(this.etapa);
          if (valid) {
          this.toggleStep(this.etapa + 1);
          }
        }
      }
    },
    toggleStep(step) {
      this.etapa = step;
    },
    saveEtapa(etapa) {
      if (etapa === 1) {
        if (!this.informacoes.Basicos.nome || !this.informacoes.Basicos.email) {
        window.toaster.emit('open', { style: "error", message: "Preencha os campos obrigatórios da etapa 1.", floater: true });
        return false;
      }
        return true;
      }
      if (etapa === 2) {
        return true;
      }
      if (etapa === 3) {
        return true;
      }
    },
    getNacionalidades() {
      UserService.nacionalidades().then(
      (response) => {
      if (response.data.length > 0) {
      this.options.nacionalidades = createSelectOptions(response.data, 'idNacionalidade', 'descricao');
      }
    },
        (error) => {
          console.error(error);
          window.spinner.emit("close");
        }
      );
    },
     getOrgaosEmissores() {
        UserService.orgaosEmissores().then(
          (response) => {
            if (response.data && response.data.length > 0) {
              this.options.rgEmissor = createSelectOptions(response.data, 'idorgaoemissor', 'nome');
            }
          },
          (error) => {
            console.error("Erro ao carregar órgãos emissores:", error);
          }
        );
      },
fetchUser() {
  console.log("currentUser:", this.currentUser);

  const unidade = this.currentUser.cadastro.Basicos.idUnidade;
  const departamento = this.currentUser.cadastro.Basicos.idDepartamento;
  const setor = this.currentUser.cadastro.Basicos.idSetor;
  const funcao = this.currentUser.cadastro.Basicos.idFuncao;
  const situacao = this.currentUser.cadastro.Basicos.idSituacao;

      this.informacoes.Basicos = {
        nome: '',
        email: '',
        telefonefixo: '',
        telefonecelular: '',
        idUnidade: unidade || null,
        idDepartamento: departamento || null,
        idSetor: setor || null,
        idFuncao: funcao || null,
        idSituacao: situacao || null,
      };

      this.informacoes.Documento = {
        rg: '',
        cpf: ''
      };

      this.informacoes.Endereco = {
        rua: '',
        numero: '',
        bairro: '',
        nomecidade: '',
        nomeUf: '',
        estado: '',
        cep: ''
      };
    },

    getAddressFromCEP() {
      const cep = this.informacoes.Endereco.cep.replace("-", "");
      if (!this.lookingForCep) {
        this.lookingForCep = true;
        window.spinner.emit('open');
        getCEP(cep).then(
          (response) => {
            if (response) {
              if (response.data.erro) {
                this.valid.cep = false;
                this.informacoes.Endereco.logradouro = null;
                this.informacoes.Endereco.bairro = null;
                this.informacoes.Endereco.nomecidade = null;
                this.informacoes.Endereco.nomeUf = null;
              } else {
                const data = response.data;
                this.informacoes.Endereco.logradouro = data.logradouro;
                this.informacoes.Endereco.bairro = data.bairro;
                this.informacoes.Endereco.nomecidade = data.localidade;
                this.informacoes.Endereco.nomeUf = data.uf;
              }
            }
            setTimeout(() => {
              this.lookingForCep = false;
              window.spinner.emit('close');
            }, 1000);
          },
          (error) => {
            console.log('error', error.request);
            setTimeout(() => {
              this.lookingForCep = false;
              window.spinner.emit('close');
            }, 1000);
          }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0; right: 10px;
    background-color: $color-bg;
    border-top: $border-component;
    padding: $hmg_mid;
    width: calc(100vw - 70px);
    z-index: 1000;

    a{
      margin-right: 5rem;
    }

    &.hom {
      bottom: 20px;
      border-left: 1px solid $color-warning;
      border-bottom: 1px solid $color-warning;
      border-bottom-left-radius: 6px;
    }
  }
  

  .etapas {
    display: flex;
    align-items: center; align-content: center;
    justify-content: center;
    gap: $hmg_mid;
    margin: 0 0 $mg 0; padding: 0;
    margin-top: 30px;

    li {
      list-style: none;
      padding: 0;
    }
  }
  .table-wrap {
    padding: $hmg $hmg_small $mg_extra;
  }
  .actions {
    display: flex;
    justify-content: space-between;
  }
    h3 { 
      margin-bottom: $hmg;
      padding-left: $hmg_small
    }
    h5 { 
      margin-top: $hmg;
      color: $color-text;
      padding-left: $hmg_small
    }
    .cargo{
      margin-left: $hmg_small;
    }

  .list-track { 
    .lists {
      display: flex;
      align-items: flex-start;
      gap: $mg_mini;
      height: 34rem;

      >div {
        flex: 1;
      }
      >span {
        font-size: 16px;
        margin-top: $hmg;
      }
      header {
        display: flex; padding: 0;
        align-items: center; align-content: center;
        justify-content: space-between;
        margin-bottom: $hmg_mid;

        p {
          margin: 0; padding: 0;
        }
      }

    .search {
      border-bottom: $border-component;
    }

      .list-selector {
        height: 35vh;
        overflow-y: auto;
        @extend %scrollbar_light;
      }

      .emptyList {
        position: relative;
        height: 35vh;
        display: flex;
        align-items: center;
        justify-content: center;

        > div {
          position: absolute;
          max-width: 200px;
          margin: auto;
          text-align: center;

          .ic {
            font-size: 64px;
          }
          h5 {
            margin-top: $mg_mini
          }
        }
      }

    ul {
      padding: 0; margin: 0;
      
      li {
        list-style: none;
        border-bottom: $border-component;
        padding: $hmg_small $mg_mid;
        cursor: pointer;
        @extend %transition_3o;
        
        &.titleItem {
          border-bottom: $border-component-double;
          padding: $hmg_small;
        }

        &:last-child {
          border: 0;
        }

        &:hover {
          background-color: $color-bg
        }
      }
    }
  }
}
</style>

